<py-catalog-header
  [hasPriceCampaign]="hasPriceCampaign"
  [numberOfSelectedCampaigns]="numberOfSelectedCampaigns"
  [priceCampaignDetails]="priceCampaignDetails"
></py-catalog-header>
<py-catalog-breadcrumb
  [showAllCategoriesLink]="true"
  [searchResults]="searchResults$ | async"
  [category]="category$ | async"
  class="py-max-width"
></py-catalog-breadcrumb>

<div class="d-flex flex-column flex-lg-row py-max-width" *ngIf="{ activeTabIndex: activeTabIndex$ | async } as data">
  <div class="filter">
    <py-catalog-filter
      *ngIf="!hasDiscontinuedArticle"
      [searchResults]="searchResults$ | async"
      [categories]="searchCategories$ | async"
      [hasAreaOfUse]="hasAreaOfUse$ | async"
      (handleFilter)="filter($event)"
      [activeTabIndex$]="activeTabIndex$"
    ></py-catalog-filter>
  </div>
  <div class="results pl-0 pl-lg-4 pl-xl-10 w-100">
    <div class="d-flex justify-content-between align-items-end mt-5 mt-lg-0">
      <ul
        ngbNav
        #nav="ngbNav"
        [activeId]="data.activeTabIndex"
        (activeIdChange)="tabSelected($event)"
        class="nav-tabs px-2 px-lg-0 w-100 mr-lg-2 active-tab-border border-bottom"
        [destroyOnHide]="false"
      >
        <li [ngbNavItem]="tabTypes.Products" [class.disabled]="(productHits$ | async) === 0 || (disableProductTab$ | async)">
          <a ngbNavLink>
            {{ 'catalog.products_tab' | cxTranslate }}
            ({{ hasDiscontinuedArticle ? substituteProducts?.length : ((productHits$ | async) || 0 | cxNumeric : '1.0-0') }})
          </a>
          <ng-template ngbNavContent>
            <py-campaign-banner-carousel
              *ngIf="hasPriceCampaign && numberOfSelectedCampaigns === 1 && priceCampaignDetails?.entries?.length > 0"
              [priceCampaignDetails]="priceCampaignDetails"
            ></py-campaign-banner-carousel>

            <ng-container
              *ngIf="{
                products: (products$ | async) || [],
                productSearchResults: searchResults$ | async,
                listItemQueryParams: listItemQueryParams$ | async,
                loadingProducts: loadingProducts$ | async,
                productsLoaded: productsLoaded$ | async
              } as observables"
            >
              <ng-container
                *ngIf="
                  (!hasDiscontinuedArticle &&
                    observables.productsLoaded &&
                    !observables.loadingProducts &&
                    observables.products?.length <= 0) ||
                  (hasDiscontinuedArticle && substituteProducts?.length <= 0)
                "
                [ngTemplateOutlet]="noResults"
              ></ng-container>

              <ng-container
                *ngIf="hasDiscontinuedArticle && substituteProducts.length > 0"
                [ngTemplateOutlet]="discontinuedArticleMessageBannerTemplate"
              ></ng-container>

              <py-campaign-items
                *ngIf="hasPriceCampaign"
                [products]="observables.products"
                [loadingProducts]="observables.loadingProducts"
                [infiniteScrollDisabled]="
                  data.activeTabIndex !== tabTypes.Products ||
                  observables.loadingProducts ||
                  observables.productSearchResults?.pagination?.currentPage + 1 ===
                    observables.productSearchResults?.pagination?.totalPages
                "
                [currentPage]="observables.productSearchResults?.pagination?.currentPage"
                [queryParams]="observables.listItemQueryParams"
              ></py-campaign-items>

              <!-- Discontinued Products -->
              <py-product-list-item-loader
                *ngIf="hasDiscontinuedArticle && substituteProducts.length > 0"
                [products]="substituteProducts"
                [substituteRefs]="substituteRefs"
                [queryParams]="observables.listItemQueryParams"
                [isSecondaryVersion]="catalogProductItemSecondary$ | async"
              ></py-product-list-item-loader>

              <py-product-list-item-loader
                *ngIf="!hasPriceCampaign && !hasDiscontinuedArticle"
                infiniteScroll
                [infiniteScrollThrottle]="300"
                [infiniteScrollDistance]="2"
                [infiniteScrollDisabled]="
                  data.activeTabIndex !== tabTypes.Products ||
                  observables.loadingProducts ||
                  observables.productSearchResults?.pagination?.currentPage + 1 ===
                    observables.productSearchResults?.pagination?.totalPages
                "
                (scrolled)="
                  nextPage(
                    observables.productSearchResults?.pagination?.currentPage + 1,
                    observables.productSearchResults?.pagination?.totalPages
                  )
                "
                [productResultRefs]="observables.productSearchResults?.productResultRefs || []"
                [products]="observables.products"
                [queryParams]="observables.listItemQueryParams"
                [isSecondaryVersion]="catalogProductItemSecondary$ | async"
              ></py-product-list-item-loader>

              <ng-container *ngIf="observables.loadingProducts" [ngTemplateOutlet]="loadingTemplate"></ng-container>

              <div
                class="col-10 col-md-4 offset-1 offset-md-4 my-4"
                *ngIf="
                  !hasDiscontinuedArticle &&
                  observables.productSearchResults &&
                  observables.products?.length > 0 &&
                  observables.productSearchResults.pagination?.totalResults > 24
                "
              >
                <py-load-more
                  [showLoadMoreButton]="false"
                  [totalItemCount]="observables.productSearchResults?.pagination?.totalResults"
                  [totalPageCount]="observables.productSearchResults?.pagination?.totalPages"
                  [currentPageNumber]="observables.productSearchResults.pagination?.currentPage"
                  [itemCount]="observables.products?.length || 0"
                  (dispatch)="nextPage($event)"
                  [totalItemCountName]="
                    'product.typeName_hint' | cxTranslate : { count: observables.productSearchResults.pagination?.totalResults }
                  "
                ></py-load-more>
              </div>
            </ng-container>
          </ng-template>
        </li>
        <li [ngbNavItem]="tabTypes.Articles" [class.disabled]="(articleHits$ | async) === 0">
          <a ngbNavLink>
            {{ 'catalog.articles_tab' | cxTranslate }}
            ({{ hasDiscontinuedArticle ? subsituteArticlesCodes?.length : ((articleHits$ | async) || 0 | cxNumeric : '1.0-0') }})
          </a>
          <ng-template ngbNavContent>
            <ng-container
              *ngIf="{
                articleSearchResults: searchResults$ | async,
                loadingArticles: loadingArticles$ | async,
                articlesLoaded: articlesLoaded$ | async,
                listItemQueryParams: listItemQueryParams$ | async
              } as observables"
            >
              <ng-container
                *ngIf="
                  (observables.articlesLoaded &&
                    !observables.loadingArticles &&
                    observables.articleSearchResults?.articleResultRefs?.length <= 0) ||
                  (hasDiscontinuedArticle && subsituteArticlesCodes?.length <= 0)
                "
                [ngTemplateOutlet]="noResults"
              ></ng-container>

              <ng-container
                *ngIf="hasDiscontinuedArticle && subsituteArticlesCodes?.length > 0"
                [ngTemplateOutlet]="discontinuedArticleMessageBannerTemplate"
              ></ng-container>

              <div *ngIf="hasDiscontinuedArticle && subsituteArticlesCodes?.length > 0" class="mx-2 mx-lg-0">
                <!-- Dicontinued Articles -->
                <py-catalog-article-list
                  [showHeader]="false"
                  [showDiscontinuedArticleHeader]="true"
                  [articleRefs]="subsituteArticlesCodes"
                  [substituteRefs]="substituteRefs"
                  [queryParams]="observables.listItemQueryParams"
                ></py-catalog-article-list>
              </div>

              <div
                *ngIf="!hasDiscontinuedArticle && observables.articleSearchResults?.articleResultRefs?.length > 0"
                class="mx-2 mx-lg-0"
                infiniteScroll
                [infiniteScrollThrottle]="300"
                [infiniteScrollDistance]="2"
                [infiniteScrollDisabled]="
                  data.activeTabIndex !== tabTypes.Articles ||
                  observables.loadingArticles ||
                  observables.articleSearchResults?.pagination?.currentPage + 1 ===
                    observables.articleSearchResults?.pagination?.totalPages
                "
                (scrolled)="
                  nextPage(
                    observables.articleSearchResults?.pagination?.currentPage + 1,
                    observables.articleSearchResults?.pagination?.totalPages
                  )
                "
              >
                <py-catalog-article-list
                  [articleResultRefs]="observables.articleSearchResults?.articleResultRefs || []"
                  [queryParams]="observables.listItemQueryParams"
                  [partialRenderingEnabled]="true"
                ></py-catalog-article-list>
              </div>

              <ng-container *ngIf="observables.loadingArticles" [ngTemplateOutlet]="loadingTemplate"></ng-container>

              <div
                class="col-10 col-md-4 offset-1 offset-md-4 my-4"
                *ngIf="
                  !hasDiscontinuedArticle &&
                  observables.articleSearchResults &&
                  observables.articleSearchResults?.articleResultRefs?.length > 0 &&
                  observables.articleSearchResults?.pagination?.totalResults > 12
                "
              >
                <py-load-more
                  [showLoadMoreButton]="false"
                  [totalItemCount]="observables.articleSearchResults?.pagination?.totalResults"
                  [totalPageCount]="observables.articleSearchResults?.pagination?.totalPages"
                  [currentPageNumber]="observables.articleSearchResults.pagination?.currentPage"
                  [itemCount]="observables.articleSearchResults?.articleResultRefs?.length || 0"
                  (dispatch)="nextPage($event)"
                ></py-load-more>
              </div>
            </ng-container>
          </ng-template>
        </li>
      </ul>
      <div class="sort-section" *ngIf="!hasDiscontinuedArticle">
        <py-catalog-sort
          class="w-100 mt-2 d-none d-lg-block"
          [searchResults$]="searchResults$"
          [activeTabIndex$]="activeTabIndex$"
        ></py-catalog-sort>
      </div>
    </div>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>

<ng-template #noResults>
  <py-no-results></py-no-results>
</ng-template>

<ng-template #loadingTemplate>
  <div class="col-4 offset-4 my-4 text-center">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>

<ng-template #discontinuedArticleMessageBannerTemplate>
  <div class="mx-2 mx-lg-0">
    <py-notification [type]="'info'">
      <span
        [innerHTML]="
          'catalog.hasDiscontinued_hint'
            | cxTranslate : { code: discontinuedArticle?.code, name: discontinuedArticle?.displayName }
        "
      ></span>
    </py-notification>
  </div>
</ng-template>
